// src/components/strumenti/ConversioneKwA.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function ConversioneKwA() {
  const [modo, setModo] = useState("kw_a"); // kw_a = da kW ad A, a_kw = da A a kW
  const [potenza, setPotenza] = useState("");
  const [corrente, setCorrente] = useState("");
  const [tensione, setTensione] = useState("400");
  const [tipo, setTipo] = useState("trifase");
  const [cosphi, setCosphi] = useState("0.9");

  const V = leggiNumero(tensione)||0, cf = leggiNumero(cosphi)||1;
  const fattore = tipo==="trifase" ? Math.sqrt(3) : 1;

  let risultato = null;
  if (modo === "kw_a") {
    const P = (leggiNumero(potenza)||0) * 1000;
    if (V>0 && cf>0) risultato = P / (fattore * V * cf);
  } else {
    const I = leggiNumero(corrente)||0;
    risultato = (fattore * V * I * cf) / 1000;
  }

  const azzera = () => { setPotenza(""); setCorrente(""); };

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("kw_a");azzera();}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="kw_a"?"#7c3aed":"#e5e7eb"}`, background: modo==="kw_a"?"#faf5ff":"#fff", color: modo==="kw_a"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>kW → A</button>
        <button onClick={()=>{setModo("a_kw");azzera();}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="a_kw"?"#7c3aed":"#e5e7eb"}`, background: modo==="a_kw"?"#faf5ff":"#fff", color: modo==="a_kw"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>A → kW</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Tipo alimentazione</label>
          <select value={tipo} onChange={e=>setTipo(e.target.value)} style={inp}>
            <option value="trifase">Trifase</option>
            <option value="monofase">Monofase</option>
          </select>
        </div>
        <div>
          <label style={lbl}>Tensione (V)</label>
          <input value={tensione} onChange={e=>setTensione(e.target.value)} style={inp}/>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>cos φ</label>
          <input value={cosphi} onChange={e=>setCosphi(e.target.value)} style={inp}/>
        </div>
        <div>
          <label style={lbl}>{modo==="kw_a" ? "Potenza (kW)" : "Corrente (A)"}</label>
          <input value={modo==="kw_a"?potenza:corrente} onChange={e=>modo==="kw_a"?setPotenza(e.target.value):setCorrente(e.target.value)} style={inp} placeholder="Es. 15"/>
        </div>
      </div>

      {(cf > 1 || cf <= 0) && <div role="alert" style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8, padding:"7px 10px", marginBottom:10, fontSize:11, color:"#991b1b" }}>Il cos φ deve essere tra 0 e 1: controlla il valore scritto.</div>}
      <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{modo==="kw_a" ? "Corrente" : "Potenza"}</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#7c3aed" }}>
          {risultato===null || isNaN(risultato) ? "—" : risultato.toLocaleString("it-IT",{maximumFractionDigits:2})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="kw_a" ? "A" : "kW"}</span>
        </div>
      </div>

      <button onClick={()=>{azzera();setTensione("400");setTipo("trifase");setCosphi("0.9");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
